/* eslint-disable no-param-reassign */
export default {
    SET_SIMPLE_PAYMENT_DETAIL_FILTER_OPTIONS({ filterOption }, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            filterOption[key] = value;
        });
    },
};
